import React, {useCallback, useMemo, useRef, useState} from 'react';
import styled from "styled-components";
import dompurify from "dompurify";
import HoverTooltip from "../HoverTooltip";

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;


const TextBox = styled(HoverTooltip)`
  flex: 1;
  .react-tooltip-lite {
    background-color: #13172B;
    height: max-content;
    flex-wrap: wrap;
    box-shadow: 0 2px 4px #00000029;
    opacity: 1;
    padding: 6px 16px;
    border-radius: 6px;
    font-weight: 300;
    font-size: 12px;
    color: #ECECEC;
    line-height: 1.4;
    text-align: ${props => {
    let align = 'center';
    if (props.textAlign) align = props.textAlign;
    return align;
}};
  }
`;


const BigTooltip = ({children, tooltipText, disabled,textColor,textAlign}) => {
    const sanitizer = dompurify.sanitize;
    const ref = useRef(null);
    //한 화면에 툴팁이 수백개 깔리는 경우(마스터리 랭킹 등) 초기 렌더에서 sanitize가 그만큼 돌아서
    //hover 하기 전까지는 툴팁 내용을 만들지 않는다.
    const [hasHovered, setHasHovered] = useState(false);

    const onHover = useCallback(() => setHasHovered(true), []);

    const renderText = useMemo(() => {
        if (tooltipText && hasHovered) {

            return (
                <div style={{maxWidth: 400,whiteSpace:'pre-wrap'}} dangerouslySetInnerHTML={{__html: sanitizer(tooltipText)}}/>
            )
        }
        return "";
    }, [tooltipText, hasHovered]);



    //어떤 광고는 zIndex값이 99999임...
    return (
        <Wrapper disabled={disabled} ref={ref} className={'bigTooltip'}
                 onMouseEnter={hasHovered ? undefined : onHover}
                 onTouchStart={hasHovered ? undefined : onHover}
                 onFocus={hasHovered ? undefined : onHover}>
            {tooltipText ?
                <TextBox content={renderText} arrow={true} arrowColor={'#13172B'} color={textColor} hoverDelay={50} distance={15} textAlign={textAlign} zIndex={999999}>
                    {children}
                </TextBox> : children}
        </Wrapper>
        // <Wrapper disabled={disabled}>
        //     {children}
        //     <AbsoluteBox className={'absoluteBox'} reverse={reverse}>
        //         {reverse && <ArrowUp/>}
        //         <TextBox>
        //             <TooltipText
        //                 dangerouslySetInnerHTML={{__html: sanitizer(tooltipText)}}
        //             >
        //             </TooltipText>
        //         </TextBox>
        //         {!reverse && <Arrow/>}
        //     </AbsoluteBox>
        // </Wrapper>
    );
};


export default BigTooltip;
